var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:hidden"},[_c('DismissableBanner',{attrs:{"show-when":true,"resource-prefix":"mobile-desktop-recommendation"}},[_vm._v("\n\t\t"+_vm._s(_vm.$t('general.mobile-desktop-recommendation'))+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }